import { formatPrice } from "@/utils/currency";
import { STATUS_CONFIG } from "@/components/orders/statusConfig";

export function StatusGroupHeader({ status, count, totalValue }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const Icon = cfg.icon;
  return (
    <div
      className={`sticky top-0 z-10 flex items-center justify-between px-4 py-2 ${cfg.bg} border-b ${cfg.border}`}
      data-testid={`status-group-${status}`}
    >
      <div className="flex items-center gap-2">
        <Icon className={`w-4 h-4 ${cfg.color}`} />
        <span className={`text-xs font-bold uppercase tracking-wider ${cfg.color}`}>{cfg.label}</span>
        <span className={`text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center text-white ${
          status === "pending" ? "bg-red-500" :
          status === "preparing" ? "bg-blue-500" :
          status === "ready" ? "bg-emerald-500" :
          status === "delivering" ? "bg-purple-500" :
          "bg-gray-400"
        }`}>
          {count}
        </span>
      </div>
      <span className="text-[10px] font-semibold text-gray-500">{formatPrice(totalValue)}</span>
    </div>
  );
}
